// extracted by mini-css-extract-plugin
export var dividerLine = "_8a-3";
export var itemImage = "_8a-9";
export var lightDivider = "_8a-4";
export var modalContent = "_8a-5";
export var modalContentCompact = "_8a-6";
export var productCard = "_8a-a";
export var productImage = "_8a-b";
export var productImageCompact = "_8a-7";
export var productImagePlaceholder = "_8a-c";
export var productImagePlaceholderCompact = "_8a-8";
export var progressBarBackground = "_8a-1";
export var progressBarContainer = "_8a-0";
export var progressBarFill = "_8a-2";